import React, { createContext, useReducer, FC, useContext, useEffect, useState } from "react";
import { useEmployeeProfileQuery } from "Hooks/useEmployeeProfileQueryContext";
import { FinalPay } from "generated/graphql";

export type ReportTerminationState = {
  finalPayType: FinalPay;
  netPay: number;
  grossPayCents?: number;
  deductionAmountCents: number;
};

export type TerminateEmployeeAction =
  | {
      type: "updateFinalPayType";
      finalPayType: FinalPay;
    }
  | { type: "updateNetPay"; netPay: number; deductionAmountCents: number; grossPayCents: number }
  | { type: "updateDeductionAmountCents"; deductionAmountCents: number }
  | { type: "resetValues" };

function reducer(
  state: ReportTerminationState,
  action: TerminateEmployeeAction
) {
  switch (action.type) {
  case "updateFinalPayType":
    return { ...state, finalPayType: action.finalPayType };
  case "updateNetPay":
    return { ...state, netPay: action.netPay, deductionAmountCents: action.deductionAmountCents, grossPayCents: action.grossPayCents };
  case "updateDeductionAmountCents":
    return { ...state, deductionAmountCents: action.deductionAmountCents };
  case "resetValues":
    return initialState;
  }
}

const initialState: ReportTerminationState = {
  finalPayType: FinalPay.DirectDepositOnly,
  netPay: 0,
  grossPayCents: 0,
  deductionAmountCents: 0,
};

interface IContextProps {
  employeeProfileId: string;
  state: ReportTerminationState;
  dispatch: React.Dispatch<TerminateEmployeeAction>;
}

export const CreatedReportTerminationContext = createContext(
  {} as IContextProps
);

export const useReportTerminationContext = () =>
  useContext(CreatedReportTerminationContext);

const ReportTerminationContext: FC = ({ children }) => {
  const [state, dispatch] = useReducer<
    React.Reducer<ReportTerminationState, TerminateEmployeeAction>
  >(reducer, initialState);
  const { userDetails } = useEmployeeProfileQuery();
  const [employeeProfileId, setEmployeeProfileId] = useState("");

  useEffect(() => {
    if (userDetails) {
      setEmployeeProfileId(userDetails.id);
    }
  }, [userDetails]);

  const value = {
    employeeProfileId,
    state,
    dispatch
  };

  return (
    <CreatedReportTerminationContext.Provider value={value}>
      {children}
    </CreatedReportTerminationContext.Provider>
  );
};

export default ReportTerminationContext;
